import { WorkoutStats } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'

export const useCurrentMonthWorkoutStats = (): UseQueryResult<WorkoutStats[], Error> => {
  return useQuery<WorkoutStats[], Error>(queryKeys.currentMonthWorkoutStats(), () => coreService.getMyCurrentMonthWorkoutStats())
}
